document.addEventListener("DOMContentLoaded", function () {
    // Check if product IDs are available
    if (!window.reviewSnapshotProductIds || !Array.isArray(window.reviewSnapshotProductIds)) return;

    // Iterate through all product IDs stored in the global variable
    window.reviewSnapshotProductIds.forEach(productId => {
        const reviewSnippet = document.getElementById(`pr-reviewsnippet-${productId}`);
        if (!reviewSnippet) return; // Skip if the element does not exist

        reviewSnippet.addEventListener("click", function () {
            const reviewSection = document.querySelector(`.section.section.section-review #Product-content-${productId}`);
            if (!reviewSection) return; // Skip if the section does not exist

            const scrollPosition = reviewSection.getBoundingClientRect().top + window.scrollY ;

            // Perform smooth scrolling
            window.scrollTo({
                top: scrollPosition,
                behavior: "smooth"
            });
        });
    });
});
